<header id="header" class="header fixed-top d-flex align-items-center">
  <div class="d-flex align-items-center justify-content-between"> <a routerLink="/dashboard"
      class="logo d-flex align-items-center">
      <!-- <img src="assets/img/logo.png" alt=""> -->
      <img [src]="dashBordLogo" alt="">
      <!-- <img src="../../../assets/img/iGBMS-dashboad.png" alt=""> -->
    </a> <i (click)="sidebarToggle()" class="bi bi-list toggle-sidebar-btn"></i>
    <!-- _router.url ==='/manageCorporates/addCorporate'" -->
    <div class="searchCorpdiv " *ngIf="searchbox && _router.url ==='/addCorporate'">
      <!-- <div class="row"> -->
      <div class="autocomplete">
        <label class="searchCorp">{{lang.Manage_Corporate_Clients}}
          <!-- <input list="browsers"  name="myBrowser" style="text-transform: capitalize;" [(ngModel)]='currentUser' (change)="fetchSeries()"/> -->
          <input list="browsers" name="myBrowser" class="input" #myInput style="text-transform: capitalize;"
            [(ngModel)]='currentUser' (blur)="dropDownDisplay=false" />
        </label>
        <ul *ngIf="dropDownDisplay" class="suggestion-list">
          <li class="dropdownLi" *ngFor="let show of searchResults" (mousedown)="diaplayinInputbox(show)">{{show.name}}
          </li>

        </ul>

        <i class="fa fa-search" aria-hidden="true" style="margin-left: 10px;" (click)="fetchSeries('myInput')"></i>
        <button class="addgroupadmininfoemp" (click)="ShowCorpDetailsDetails()"
          *ngIf="showAddButton">+&nbsp;{{lang.Add}}</button>
        <button class="editgroupadmininfoemp" *ngIf="showeditcorp" (click)="EditCorpDetails()"><i
            class="fa fa-edit"></i>&nbsp;{{lang.Edit}}</button>
      </div>
    </div>

    <div class="searchCorpdiv" *ngIf="_router.url.includes('edit-corporate')">
      <table class="employeelist">
        <tr>
          <th style="padding:0px; font-weight:normal">{{lang?.Corporate_Customer_Name??'Corporate Customer Name'}}: 
            <span style="color:black; font-weight:bold"
              class="text-capitalize">{{clientName}}</span></th>
          <!-- <th style="padding:15px">Corporate Client ID:<span style="color:black">{{ClientId}}</span></th> -->
          <th style="padding:30px; font-weight:normal">{{lang.Account_Status}}: 
            <span style="color:black; font-weight:bold">{{appStatus}}</span></th>
        </tr>
      </table>
    </div>
    <!-- &&_router.url ==='/manageMembers/employee' -->
    <!-- <span style="color:black" class="text-capitalize">Member Name:&nbsp;<b>{{memberUserName}}</b></span> -->

    <div class="searchCorpdiv" *ngIf="_router.url.includes('/manageMembers/employee') && memberUserName">
      <span style="color:black" class="">{{lang.Member_Name}}:&nbsp;<b>{{memberUserName}}</b></span>
    </div>
  </div>

  <!-- <div 
    *ngIf="portalInfo?.name!=undefined" 
    style = "padding-left: 280px; white-space: nowrap;"
    >
      {{portalInfo?.name}} Portal
  </div> -->

  <nav class="header-nav ms-auto">
   
    <ul class="d-flex align-items-center">
      <li class="nav-item dropdown1">
        <select class=" ng-pristine ng-invalid ng-touched" id="planenrollmentdate" placeholder="Select" (change)="languageSelect($event)" [(ngModel)]="showlang">
          <!-- <option label="" value="">Select Language</option> -->
          <option value="English" label="English" selected>English</option>
          <option value="French" label="French">French</option>
          <option value="Spanish" label="Spanish">Spanish</option>
        </select>

      </li>&nbsp;&nbsp;


    </ul>
  </nav>
  <!-- <li class="nav-item dropdown1 pe-3">
    <a class="dropdown-item d-flex align-items-center" routerLink="/login" (click)="logout()"> <i class="bi bi-box-arrow-right" ></i>&nbsp;<span>Log Out</span> </a>


  </li> -->

  <div class="dropdown">
    <button class="btn d-flex mt-1 me-2" type="button" id="dropdownMenuButton1" style="width:300px"
      data-bs-toggle="dropdown" aria-expanded="false">
      <!-- <i class="fa fa-user" aria-hidden="true" style="font-size:25px"></i> -->
      <div class="d-flex flex-column w-100">
        <span>{{lang.Welcome}} &nbsp;<b class="text-center">{{(userInfo?.name ?? portalInfo?.name) |titlecase }}</b></span>
        <span style="font-size:14px;padding-left: 30px;">{{(userInfo?.role ?? portalInfo?.role ?? role) |titlecase }}</span>
      </div>
      <i class="fa fa-caret-down mt-1" aria-hidden="true" style="font-size:12px"></i>
    </button>

    <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1" style="width: 100%">

      <li class="nav-item">

        <a class="dropdown-item d-flex align-items-center collapsed d-flex align-items-center" data-bs-target="#profile"
          data-bs-toggle="collapse" href="#" (click)="toggleChevron($event)"><i class="fa fa-users"
            aria-hidden="true"></i>&nbsp;<span class="ps-1">{{lang.Switch_Profiles}}</span>
          <i [ngClass]="{'bi-chevron-right': showChevronSettings, 'bi-chevron-down': !showChevronSettings}"
            class="ms-auto pe-1"></i>
        </a>
        <ul id="profile" class="nav-content collapse ulheigh">
          <li *ngIf="profiles && profiles.length>0" class="linescrollbar"
            style="max-height:200px;overflow-y:auto;overflow-x: hidden;">
            <div *ngFor="let profile of profiles">
              <a class="dropdown-item d-flex align-items-center" style="cursor:pointer"
                (click)="redirectToProfile(profile)">
                <!-- <i class="fa fa-user" aria-hidden="true"></i>&nbsp; -->
                <div class="ps-3 row">
                  <!-- <span>{{profile?.type=="BROKER"?"Advisor":profile?.name}}</span> -->

                  <div class="d-flex">
                    <span style="margin-right: 10px;"> <img style="height: 33px;" class="image" src={{matchedImages(profile?.type)}} alt="admin logo" /></span>
                    <span class="d-flex flex-column">
                      <!-- <span><i class="fa fa-user" aria-hidden="true"></i></span> -->
                      <span class="text-wrap">
                        {{profile?.name}}
                      </span>
                      <span style="font-size:9px;" class="text-capitalize" *ngIf="profile?.type">
                        Login as {{profile?.type}}
                    </span>
                    </span>

                    
                  </div>
                  <!-- <div class="col-6" style="font-size:13px">&nbsp;</div> -->

                </div>
              </a>
            </div>
          </li>

           <li *ngIf="profiles && profiles.length==0" class="linescrollbar"
            style="max-height:200px;overflow-y:auto;overflow-x: hidden;">
            <span class="text-wrap" style="margin-left: 52px; font-size: 13px; font-style: italic;">
                        No profiles to switch
                      </span>
          </li>
        </ul>


      </li>



      <li><a class="dropdown-item d-flex align-items-center" *ngIf="" (click)="showProfiles()" style="cursor:pointer"><i
            class="fa fa-user" aria-hidden="true"></i>&nbsp;<span class="ps-1">{{lang.Switch_Profiles}}</span></a></li>
      <li><a class="dropdown-item d-flex align-items-center" (click)="changepassword()" style="cursor:pointer"><i
            class="fa fa-key" aria-hidden="true"></i>&nbsp;<span>{{lang.Change_Password}}</span></a></li>

      <li><a class="dropdown-item d-flex align-items-center" (click)="logout()"> <i
            class="bi bi-box-arrow-right"></i>&nbsp;<span>{{lang.Log_Out}}</span> </a></li>


    </ul>
  </div>

</header>

<!-- <app-mange-clients></app-mange-clients> -->




<!-- changepassword model -->

<div class="modal" id="changepassword" tabindex="-1" role="dialog" aria-labelledby="changepasswordLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h6 class="modal-title">{{lang.Change_Password}}</h6>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true" (click)="closeChangepassmodel()">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <form [formGroup]="changepasswordform">
          <div class="row">
            <div class="form-group col-1"></div>
            <div class="form-group col-10">
              <label for="Corporation" class="Corporation">{{lang.Old_Password}}<span style="color: red">*</span></label>

              <input type="password" class="form-control checking-field" id="nameofcorporation"
                placeholder={{lang.Old_Password}} formControlName="oldpassword" />

              <div *ngIf="changepass['oldpassword'].touched && changepass['oldpassword'].invalid"
                class="help-block text-danger">
                <div *ngIf="changepass['oldpassword'].errors && changepass['oldpassword'].errors['required']">Please
                  {{lang.enter_old_password}}</div>
                <div *ngIf="changepass['oldpassword'].errors && changepass['oldpassword'].errors['minlength']">
                  {{lang.Password_must_be_at_least_8_characters}}</div>
                <div *ngIf="changepass['oldpassword'].errors && changepass['oldpassword'].errors['maxlength']">
                  {{lang.Password_must_not_exceed_40_characters}}</div>
              </div>

            </div>
            <div class="form-group col-1"></div>
          </div>
          <div class="row">
            <div class="form-group col-1"></div>
            <div class="form-group col-10">
              <label for="Corporation" class="Corporation">{{lang.New_Password}}<span style="color: red">*</span></label>

              <input type="password" class="form-control checking-field" id="nameofcorporation"
                placeholder={{lang.New_Password}} formControlName="newpassword" />
              <div *ngIf="changepass['newpassword'].touched && changepass['newpassword'].invalid"
                class="help-block text-danger">
                <div *ngIf="changepass['newpassword'].errors && changepass['newpassword'].errors['required']">
                  {{lang.Please_enter_new_password}}</div>
                <div *ngIf="changepass['newpassword'].errors && changepass['newpassword'].errors['minlength']">
                  {{lang.Password_must_be_at_least_8_characters}}</div>
                <div *ngIf="changepass['newpassword'].errors && changepass['newpassword'].errors['maxlength']">
                  {{lang.Password_must_not_exceed_40_characters}}</div>
              </div>

            </div>
            <div class="form-group col-1"></div>
          </div>
          <div class="row">
            <div class="form-group col-1"></div>
            <div class="form-group col-10">
              <label for="Corporation" class="Corporation">{{lang.Confirm_Password}}<span style="color: red">*</span></label>

              <input type="password" class="form-control checking-field" id="nameofcorporation"
                placeholder={{lang.Confirm_Password}} formControlName="confirmpassword" />
              <div *ngIf="changepass['confirmpassword'].touched && changepass['confirmpassword'].invalid"
                class="help-block text-danger">
                <div *ngIf="changepass['confirmpassword'].errors && changepass['confirmpassword'].errors['required']">
                  {{lang.Please_enter_confirm_password}}</div>
                <div *ngIf="changepass['confirmpassword'].errors && changepass['confirmpassword'].errors['minlength']">
                  {{lang.Password_must_be_at_least_8_characters}}</div>
                <div *ngIf="changepass['confirmpassword'].errors && changepass['confirmpassword'].errors['maxlength']">
                  {{lang.Password_must_not_exceed_40_characters}}</div>
                <div
                  *ngIf="changepass['confirmpassword'].errors && changepass['confirmpassword'].errors['confirmedValidator']">
                  {{lang.Passwords_did_not_match}}</div>
              </div>

            </div>
            <div class="form-group col-1"></div>
          </div>

        </form>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-primary submitbutton" [disabled]="changepasswordform.invalid"
          (click)="SubmitChangePassword()">{{lang.Submit}}</button>
        <button type="button" class="btn btn-secondary" data-dismiss="modal"
          (click)="closeChangepassmodel()">{{lang.Close}}</button>


      </div>
    </div>
  </div>
</div>

<!-- Profiles Modal -->

<div class="modal" id="switchProfileModal" tabindex="-1" role="dialog" aria-labelledby="switchProfileModal"
  aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h6 class="modal-title">{{lang.Profiles}}</h6>
        <i (click)="closeSwitchProfileModal()" data-dismiss="modal" class="bi bi-x-circle" role="button"
          aria-hidden="true" data-bs-dismiss="modal"></i>
      </div>
      <div class="modal-body">

        <div class="d-flex justify-content-center gap-2 flex-wrap ">
          <div *ngFor="let profile of profiles">
            <div (click)="redirectToProfile(profile)"
              class="profile-card p-2 col-md-3 border shadow rounded text-center position-relative"
              style="height:150px;width:200px;border-color:#5d739b;border-width:3px !important;cursor: pointer;">

              <div class="position-absolute " style="top:0;right:0;left:0;height:40%;width:100%;">
                <img class="p-1 h-100 w-100" [src]="profile.logo ? profile.logo : '../../../assets/img/logo.png'" />
              </div>

              <div class="d-flex flex-column gap-1">
                <div class="mt-5 fw-bold">{{profile.type=="BROKER"?"ADVISOR":profile.name}}</div>
                <span>{{profile.type=="BROKER"?"ADVISOR":profile.name}}</span>
                <span style="font-size:13px">{{profile.portalName?.split(' ')[0]}}</span>
                <span style="font-size:13px" class="text-capitalize">{{profile.type?.split("_").length > 2?
                  profile.type?.split("_")[1]?.toLowerCase()+'
                  '+profile.type?.split("_")[2]?.toLowerCase():profile.type?.split("_")[1]?.toLowerCase()}}</span>
              </div>

            </div>
          </div>


        </div>
      </div>
      <!-- <div class="modal-footer">
        <button type="button" class="btn btn-primary submitbutton" [disabled]="changepasswordform.invalid"
          (click)="SubmitChangePassword()">Submit</button>
        <button type="button" class="btn btn-secondary" data-dismiss="modal"
          (click)="closeSwitchProfileModal()">Close</button>


      </div> -->
    </div>
  </div>
</div>
